import request from '@/router/axios'
import env from '@/config/env'

/**
 * 区域下拉列表
 * @returns 返回区域列表
 */
export const areaSelect = () => {
  return request({
    url: env.ferryUrl + '/stationManage/area',
    method: 'get'
  })
}

/**
 * 获取低级归属区域数据
 * @param data
 */
export const getRegionTree = () => {
  return request({
    url: env.ferryUrl + '/areaManage/tree',
    method: 'post'
  })
}

// 获取省市区地址 JSON文件
export const distinct = () => {
  return request({
    url: 'https://webapi.amap.com/ui/1.1/ui/geo/DistrictExplorer/assets/d_v1/country_tree.json',
    method: 'get',
    headers: {
      'X-THIRD-PARTY': true
    }
  })
}

/**
 * 站点列表
 */
export const siteList = () => {
  return request({
    url: env.ferryUrl + '/commonAdmin/getStationSelect',
    method: 'GET'
  })
}

/**
 *  供应商列表
 */
export const merchantList = () => {
  return request({
    url: env.ferryUrl + '/commonAdmin/getMerchantSelect',
    method: 'GET'
  })
}

/**
 * 司机信息列表
 */
export const driverInfoList = () => {
  return request({
    url: env.ferryUrl + '/orderAdmin/getDriverForParam',
    method: 'GET'
  })
}

/**
 * 获取财务统计下拉供应商
 */
export const selectMerchantForFinance = () => {
  return request({
    url: env.ferryUrl + '/flightManage/queryMerchantList',
    method: 'GET'
  })
}

/**
 * 获取日志
 */
export const getLog = (params) => {
  return request({
    url: env.ferryUrl + '/bizLog/getBizLogList',
    method: 'GET',
    params
  })
}

/**
 * 上报异常日志
 */
export const uploadErrorLog = (data) => {
  return request({
    url: env.ferryUrl + '/bizLog/frontLog',
    method: 'POST',
    data
  })
}

/**
 * 获取用户信息
 */
export const getUserInfo = (data) => {
  return request({
    url: env.ferryUrl + '/common/user/intro',
    method: 'GET',
    params: data
  })
}
